/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  RadarEntry,
  TechRadarLoaderResponse,
  TechRadarApi,
} from '@backstage/plugin-tech-radar';
import quadrants from './config/quadrants';
import rings from './config/rings';
import plataforms from './plataforms';
import techniques from './techniques';
import tools from './tools';
import languagesAndFrameworks from './languages-and-frameworks';

const entries: RadarEntry[] = [
  ...plataforms,
  ...techniques,
  ...tools,
  ...languagesAndFrameworks
];

export const mock: TechRadarLoaderResponse = {
  entries,
  quadrants,
  rings,
};

export class CobliTechRadarApi implements TechRadarApi {
  async load() {
    return mock;
  }
};
